<template>
	<div>
		<v-dialog v-model="showDialog" max-width="700" lazy persistent>
			<v-card class="pa-4 pos-rel">
				<div class="closeBtn-top-right">
					<v-btn flat fab @click="closeDialog">
						<v-icon>close</v-icon>
					</v-btn>
				</div>

				<h5 class="heading mb-3">Take Action on the user</h5>

				<v-tabs-items v-model="activeTab">
					<v-tab-item value="tab-1" class="pa-3">
						<v-layout
							class="full-width pos-rel profile-card verCenteredChild mb-4"
						>
							<img :src="userCoverPic" class="full-cover cover" />
							<div class="background-overlay-1 full-cover"></div>
							<div class="pos-abs verCenteredChild">
								<v-avatar size="75" class="mx-3">
									<img :src="userPic" />
								</v-avatar>
								<div class="px-1">
									<div class="headline white--text">
										{{ name }}
									</div>
									<div class="heading white--text">
										@{{ handle }}
									</div>
								</div>
							</div>
						</v-layout>

						<v-layout row wrap class="full-width">
							<v-flex xs6>
								<v-text-field
									v-model="name"
									:color="themeInputColor"
									label="Name*"
								></v-text-field>
							</v-flex>
							<v-flex offset-xs1 xs5>
								<v-select
									:items="allLangData"
									label="Select Language"
									v-model="langValueLocal"
									hide-details
									:color="themeInputColor"
									required
								></v-select>
							</v-flex>
						</v-layout>

						<v-layout>
							<v-flex xs6>
								<v-text-field
									label="Email"
									v-model="email"
									:rules="[checkValidEmail]"
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout>
							<v-flex xs6>
								<v-text-field
									label="Choose Username*"
									readonly
									v-model="dashboardUsername"
									:rules="[requiredRule]"
								></v-text-field>
							</v-flex>
							<v-flex class="no-flex-grow verCenteredChild mx-3">
								<v-tooltip right>
									<v-icon slot="activator">info</v-icon>
									<span>Username cannot be changed!</span>
								</v-tooltip>
							</v-flex>
						</v-layout>

						<v-layout class="mb-3">
							<v-flex xs6>
								<v-text-field
									label="Phone number*"
									v-model="phone"
								></v-text-field>
							</v-flex>
							<v-flex class="no-flex-grow verCenteredChild mx-3">
								<v-tooltip right>
									<v-icon
										slot="activator"
										:color="themeInputColor"
										>check_circle</v-icon
									>
									<span>Verified</span>
								</v-tooltip>
							</v-flex>
						</v-layout>

						<v-layout class="verCenteredChild pt-1 mb-2">
							<span
								class="subheading pr-4 mb-3 pb-1 grey-color-text"
								>Select Gender:</span
							>
							<v-radio-group
								:color="themeInputColor"
								v-model="gender"
								class="pa-0 ma-0"
								:rules="[requiredRule]"
							>
								<v-layout>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="Male"
											value="M"
											class="my-0"
										></v-radio>
									</v-flex>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="Female"
											class="my-0"
											value="F"
										></v-radio>
									</v-flex>
								</v-layout>
							</v-radio-group>
						</v-layout>

						<select-state-city-mm
							:defaultState="selectedState"
							:defaultCity="selectedCity"
							:defaultMicroMarket="selectedMicroMarket"
						/>
						<div class="ma-2" v-if="jeet11Executive === storeType">
							Distributor Phone No: <b>{{ dstrPhone }}</b>
						</div>
						<v-layout
							v-if="jeet11Executive === storeType"
							class="justify-center ma-2"
						>
							<v-data-table
								:headers="jeet11ActiveExecutiveDataHeaders"
								:items="jeet11ActiveExecutiveData"
								class="elevation-1"
							>
								<template v-slot:items="props">
									<td>{{ props.item.userId }}</td>
									<td>{{ props.item.retailerName }}</td>
									<td>{{ props.item.state }}</td>
									<td>{{ props.item.city }}</td>
									<td>{{ props.item.phoneNo }}</td>
								</template>
							</v-data-table>
						</v-layout>
						<v-layout v-if="tsmPhoneNumber">
							<v-flex xs6>
								<v-text-field
									label="TSM Phone No"
									v-model="tsmPhoneNumber"
									:color="themeInputColor"
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout v-if="rbmPhoneNumber">
							<v-flex xs6>
								<v-text-field
									label="RBM Phone No"
									v-model="rbmPhoneNumber"
									:color="themeInputColor"
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-template v-if="storeType === jeet11Retailer">
							<v-layout class="verCenteredChild pt-1 mb-0">
								<span
									class="subheading pr-4 mb-3 pb-1 grey-color-text"
									>Are you a shop owner?</span
								>
								<v-radio-group
									:color="themeInputColor"
									v-model="isShopOwner"
									class="pa-0 ma-0"
								>
									<v-layout>
										<v-flex>
											<v-radio
												:color="themeInputColor"
												label="Yes"
												value="true"
												class="my-0"
											></v-radio>
										</v-flex>
										<v-flex>
											<v-radio
												:color="themeInputColor"
												label="No"
												class="my-0"
												value="false"
											></v-radio>
										</v-flex>
									</v-layout>
								</v-radio-group>
							</v-layout>
							<v-layout>
								<v-flex xs6 class="pr-4">
									<v-select
										:items="possibleReferrers"
										label="Referrer Type"
										v-model="referrerType"
										:value="incorporationType"
										:color="themeInputColor"
										required
									></v-select>
								</v-flex>
								<v-text-field
									label="Referrer Phone"
									v-model="referrerPhone"
									:color="themeInputColor"
									:rules="[validPhoneNoRule]"
								></v-text-field>
							</v-layout>
						</v-template>

						<v-layout>
							<v-spacer />
							<!-- <v-btn flat :color="themeInputColor">Reject</v-btn> -->
							<v-btn
								class="white--text ma-0"
								:color="themeInputColor"
								@click="activeTab = 'tab-2'"
								>Next</v-btn
							>
						</v-layout>
					</v-tab-item>

					<v-tab-item value="tab-2">
						<v-layout row wrap class="allCenteredChild mb-4 pa-3">
							<v-flex
								v-for="item in documentTypes"
								:key="item.key"
								xs5
								class="mb-4 px-4"
							>
								<img
									:src="item.src"
									@error="imageLoadOnError"
									class="document-image d-block"
									@click="openFullImage(item.key)"
								/>
								<div
									class="subheading text-center grey--text mt-2"
								>
									{{ item.name }}
								</div>
							</v-flex>
						</v-layout>

						<v-layout>
							<v-btn
								flat
								class="ma-0"
								:color="themeInputColor"
								@click="activeTab = 'tab-1'"
								>Back</v-btn
							>
							<v-spacer />
							<v-btn
								outline
								:color="themeInputColor"
								:loading="rejectActionLoading"
								@click="takeActionOnRetailer('reject')"
								>Reject</v-btn
							>
							<v-btn
								class="white--text"
								:color="themeInputColor"
								:loading="approveActionLoading"
								@click="takeActionOnRetailer('approve')"
								>Approve</v-btn
							>
						</v-layout>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-dialog>

		<v-dialog v-model="fullImageDialog" max-width="650">
			<img :src="fullImageSrc" class="d-block full-width" />
		</v-dialog>
	</div>
</template>

<script>
import { mapState } from "vuex";
import SelectStateCityMM from "@/components/select-state-city-mm";
import {
	TAKE_ACTION_ON_REGISTRATION,
	FETCH_ACTIVE_EXECUTIVE_UNDER_DSTR
} from "@/store/action-types";
import * as utils from "@/utils";

import fallBackImage from "@/assets/bar-img-unavailable.png";
import { JEET11_RETAILER, JEET11_EXECUTIVE } from "../../constants";

export default {
	name: "UserReviewForm",
	props: ["themeInputColor", "showDialog", "retailerDetails"],
	data() {
		return Object.assign(
			{},
			{
				activeTab: "tab-1",
				checkValidEmail: v => utils._checkValidEmail(v),
				requiredRule: v => utils._requiredRule(v),
				rejectActionLoading: false,
				approveActionLoading: false,
				fallBackImage,
				possibleReferrers: utils.possibleReferrers,
				jeet11Retailer: JEET11_RETAILER,
				jeet11Executive: JEET11_EXECUTIVE,
				jeet11ActiveExecutiveData: [],
				jeet11ActiveExecutiveDataHeaders: [
					{
						text: `Executive Id`,
						value: `userId`,
						align: "center",
						sortable: false
					},
					{
						text: `Name`,
						value: `retailerName`,
						align: "center",
						sortable: false
					},
					{
						text: `State`,
						value: `state`,
						align: "center",
						sortable: false
					},
					{
						text: `City`,
						value: `city`,
						align: "center",
						sortable: false
					},
					{
						text: `Phone No`,
						value: `phoneNo`,
						align: "center",
						sortable: false
					}
				]
			},
			initialState
		);
	},
	components: {
		"select-state-city-mm": SelectStateCityMM
	},
	computed: {
		...mapState({
			allLangData: state => state.common.allLangData.map(el => el.lang.S)
			// takeActionOnRegistrationLoading: "takeActionOnRegistrationLoading"
		}),
		documentTypes() {
			return [
				{ name: "ID Proof", src: this.IDProof, key: "IDProof" },
				{
					name: "GST Certificate",
					src: this.GSTCertificate,
					key: "GSTCertificate"
				},
				{
					name: "Certificate of Incorporation",
					src: this.COI,
					key: "COI"
				},
				{ name: "Agreement", src: this.agreement, key: "agreement" }
			];
		}
	},
	methods: {
		closeDialog() {
			this.$emit("CLOSE_DIALOG");
			this.activeTab = "tab-1";
		},
		imageLoadOnError(e) {
			e.target.src = this.fallBackImage;
		},
		openFullImage(type) {
			this.fullImageSrc = this.documentTypes.filter(
				el => el.key === type
			)[0].src;
			this.fullImageDialog = true;
		},
		takeActionOnRetailer(action) {
			this.takeActionLoading = true;
			let loadingKey = `${action}ActionLoading`;
			this[loadingKey] = true;
			// console.log("loadingKey: ", loadingKey);
			this.$store
				.dispatch(TAKE_ACTION_ON_REGISTRATION.dispatch, {
					userId: this.userId,
					action,
					lang: this.langValueLocal,
					city: this.selectedCity,
					state: this.selectedState,
					micro_market: this.selectedMicroMarket,
					gender: this.gender,
					name: this.name,
					referrerType: this.referrerType,
					referrerPhone: this.referrerPhone
				})
				.then(() => {
					this[loadingKey] = false;
					this.closeDialog();
				})
				.catch(err => {
					console.error(err);
					this[loadingKey] = false;
				});
		},
		fetchActiveExecutiveUnderDstr(dstrPhone) {
			this.$store
				.dispatch(FETCH_ACTIVE_EXECUTIVE_UNDER_DSTR.dispatch, {
					dstrPhone
				})
				.then(resp => {
					this.jeet11ActiveExecutiveData = resp;
				})
				.catch(err => console.log(err));
		}
	},
	watch: {
		retailerDetails(newVal) {
			if (newVal) {
				this.userId = newVal.id;
				this.name = newVal.name;
				this.handle = newVal.handle;
				this.email = newVal.email;
				this.storeType = newVal.storeType;
				this.dashboardUsername = newVal.handle;
				this.langValueLocal = newVal.language;
				this.phone = newVal.phone;
				this.selectedCity = newVal.city;
				this.selectedState = newVal.state;
				this.selectedMicroMarket = newVal.micro_market;
				this.userCoverPic = newVal.coverPic;
				this.userPic = newVal.pic;
				this.gender = newVal.gender;
				this.COI = newVal.COI;
				this.GSTCertificate = newVal.GSTCertificate;
				this.IDProof = newVal.IDProof;
				this.agreement = newVal.agreement;
				this.isShopOwner = newVal.isShopOwner
					? newVal.isShopOwner.toString()
					: "false";
				this.referrerType = newVal.referrerType;
				this.referrerPhone = newVal.referrerPhone;
				this.tsmPhoneNumber = newVal.tsmPhoneNumber || "";
				this.rbmPhoneNumber = newVal.rbmPhoneNumber || "";
				this.dstrPhone = newVal.dstrPhone || "";
			}
			if (this.jeet11Executive === newVal.storeType) {
				this.fetchActiveExecutiveUnderDstr(newVal.dstrPhone);
			}
		}
	}
};
const initialState = {
	userId: null,
	name: null,
	handle: null,
	langValueLocal: null,
	email: null,
	phone: null,
	dashboardUsername: null,
	gender: null,
	COI: null,
	IDProof: null,
	GSTCertificate: null,
	agreement: null,
	selectedState: null,
	selectedCity: null,
	selectedMicroMarket: null,
	userCoverPic: null,
	userPic: null,
	fullImageSrc: null,
	fullImageDialog: false,
	storeType: null,
	isShopOwner: null,
	referrerType: null,
	referrerPhone: null,
	tsmPhoneNumber: null,
	rbmPhoneNumber: null
};
</script>

<style lang="scss" scoped>
.profile-card {
	height: 100px;
	border-radius: 8px;
	overflow: hidden;
}
.document-image {
	height: 200px;
	width: 100%;
	object-fit: cover;
	object-position: center;
	border: 2px dashed #ddd;
}
.closeBtn-top-right {
	top: 4%;
	right: 4%;
	position: absolute;
	transform: translateX(50%) translateY(-50%);
}
</style>
